<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="500" width="500">
      <v-card class="align-self-center">
        <v-card-text class="pt-5">
            <SendOtp @closeDialog="dialog = false" v-if="showOtp" :otpDialogAction="otpDialogAction" :userData="userData"/>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import CurrentUser from '@/components/mixins/CurrentUser';
import SendOtp from '@/components/OTP/SendOtp.vue';

export default {
  mixins: [CurrentUser],
  components: { SendOtp },
  data() {
    return {
      dialog: false,
      otpDialogAction: 'default',
      dataFromInvoker: false,
      userData: null
    };
  },
  computed: {
    showOtp() {
      return this.$auth.loggedIn || this.dataFromInvoker;
    }
  },
  mounted() {
    this.$nuxt.$on('openOTP', this.openOTP);
  },
  methods: {
    /** getter
     * @return {Boolean} displayOtp according to user email verification status
     */
    openOTP(action, userData = null) {
      if (userData != null) {
        this.dataFromInvoker = true;
        this.userData = userData;
        this.dialog = true;
      } else if (this.displayOtp) {
        console.log(' email is not valid - open opt dialog ');
        this.otpDialogAction = action;
        this.dialog = true;
      }
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('openOTP');
  }
};
</script>
